import { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { registerUserRequest, loginRequest } from "../functions/api_calls";
import { AppContext } from "../../../context/context";
import { setToken, resolveRoleFromDecoded } from '../functions/authentication_management';
import { DecodedAuthToken } from "../types/AuthTypes";
import { jwtDecode } from "jwt-decode";

export default function useRegisterHandler() {
  const { t } = useTranslation('auth');
  const context = useContext(AppContext);

  if (!context) {
    throw new Error("useRegisterHandler must be used within the app provider");
  }

  const { userData } = context;
  const { setUserDetails } = userData;

  const handleRegister = async (username: string, password: string, fullName: string) => {
    try {
      await registerUserRequest(username, password, fullName);
    } catch {
      console.log("There was an issue registering the user");
      throw new Error(t('loginModal.registerError'));
    }

    const results = await loginRequest(username, password);

    if (results.auth_token == null) {
      console.log("No token found?");
      throw new Error(t('loginModal.noTokenError'));
    }

    setToken(results.auth_token);
    const decodedToken = jwtDecode<DecodedAuthToken>(results.auth_token);
    const userId = decodedToken.user_id;

    setUserDetails({
      email: username,
      fullName: fullName,
      userId: userId,
      role: resolveRoleFromDecoded(decodedToken),
      customerId: null,
    });
  };

  return handleRegister;
}
